/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ContextsInputs */

const de__field_contexts = /** @type {(inputs: _Field_ContextsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontext der Rolle`)
};

/**

* @param {_Field_ContextsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_contexts = /** @type {((inputs?: _Field_ContextsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ContextsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contexts(inputs)
});